module.exports = __webpack_public_path__ + "static/media/ele-tutor-two.67f8039a.jpg";